<script>
    import {onMount} from "svelte";
    import Library from '../../../Models/LibraryORM';
    import Loader from '../../Loader.svelte';
    import {addFormModal} from '../../../Forms/ModalFormManager.svelte';
    import {forms} from '../../../lib/forms';
    import {uuid} from '../../../Database.svelte';
    import {confirm} from '../../Confirmation.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import TagEditor from "../../../Forms/CustomFields/TagEditor.svelte";

    export let section;
    export let assessment_type_model;

    let formFields;

    function saveField(field) {
        if (field.id) {
            section.extra_fields = section.extra_fields.map(f => {
                if (f.id == field.id) {
                    return field
                }
                return f
            })
        } else {
            field.id = uuid();
            section.extra_fields = [...section.extra_fields, field];
        }

        saveSection();
    }

    function saveSection(message="Section Updated") {
        assessment_type_model.saveSection(section).then(() => {
            notifier.success(message)
        });
    }


    function addField() {
        addFormModal({
            fields: forms['customForm']
        }).then(saveField).catch(() => {});
    }


    function editField(field) {
        let data = JSON.parse(JSON.stringify(field));
        addFormModal({
            fields: forms['customForm'],
            data
        }).then(saveField).catch(() => {});
    }

    function removeField(field) {
        confirm(`Are you sure you want to remove ${field.name}?`).then(() => {
            section.extra_fields = section.extra_fields.filter(f => f.id != field.id);
            saveSection();
        }).catch(() => {});
    }

    function manageTags() {
        addFormModal({
            fields: [{name: 'tags', type: "custom", "component": TagEditor, label: "Tags"}],
            data: {
                tags: section.tags
            }
        }).then(data => {
            section.tags = data.tags;
            saveSection();
        });
    }

    function toggleExcludeMappings() {
        section.exclude_mappings = !section.exclude_mappings;

        saveSection(`Library Mappings ${section.exclude_mappings ? "Excluded" : "Included"}`);
    }

    onMount(async () => {
        if (!section.tags) {
            section.tags = [];
        }

        if (!section.extra_fields) {
            section.extra_fields = [];
        }
        formFields = (await Library.getFieldData(section.library_type)).formFields;
    });
</script>

<Loader loading={!formFields}>
    <h2 class="title is-2">
        Tags
        <button class="button is-info" on:click={manageTags}>Manage</button>
    </h2>
    <div class="fields content">
        {#each section.tags as tag (tag.id)}
            <div class="field">
                <p class="control">
                    <button class="button is-{tag.color_class || 'info'}" >{tag.name}</button>
                </p>
            </div>
        {/each}
    </div>

    <h2 class="title is-2">Fields</h2>
    <table class="table is-striped is-fullwidth">
        <thead>
            <tr>
                <th>Field Name</th>
                <th>Field Type</th>
                <th>Required</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td colspan="4">
                    <div class="buttons is-right">
                        <button class="button is-info" class:is-light={!section.exclude_mappings} on:click={toggleExcludeMappings}>Exclude Library Mappings</button>
                        <button class="button is-success" on:click={addField}>Add Field</button>
                    </div>
                </td>
            </tr>
        </tfoot>
        <tbody>
            {#each formFields as field}
                <tr>
                    <td>
                        {field.name}
                    </td>
                    <td>
                        {field.type}
                    </td>
                    <td>
                        {field.required}
                    </td>
                    <td>
                        Library Field
                    </td>
                </tr>
            {/each}
            {#each section.extra_fields as field (field.id)}
                <tr>
                    <td>
                        {field.name}
                    </td>
                    <td>
                        {field.type}
                    </td>
                    <td>
                        {field.required}
                    </td>
                    <td>
                        <button class="button is-info" on:click={() => editField(field)}>Edit</button>
                        <button class="button is-danger" on:click={() => removeField(field)}>Delete</button>
                    </td>
                </tr>
            {/each}
        </tbody>
    </table>
</Loader>

<style>
    .fields {
        display: flex;
        gap: 0.75rem;
        flex-wrap: wrap;
        margin-top: .75rem;
    }
</style>
